function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useState } from 'react';
/**
 * Returns a selectedKey and onChange handler that can manage selection state
 * for both controlled and uncontrolled components. Useful for cases where a
 * component needs to always track its selection state regardless of its
 * controlled / uncontrolled status.
 */
export function useOnChangeTrackUncontrolled(_ref) {
  var defaultSelectedKey = _ref.defaultSelectedKey,
    selectedKey = _ref.selectedKey,
    onChangeHandler = _ref.onChange;
  // `null` is a valid value for `selectedKey` in controlled mode, so we check
  // for explicit `undefined` to identify uncontrolled mode.
  var isUncontrolled = selectedKey === undefined;
  var _useState = useState(defaultSelectedKey),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledSelectedKey = _useState2[0],
    setUncontrolledSelectedKey = _useState2[1];
  var onChangeMaybeUncontrolled = useCallback(key => {
    // If our component is uncontrolled, track the selected key internally
    if (isUncontrolled) {
      setUncontrolledSelectedKey(key);
    }
    onChangeHandler === null || onChangeHandler === void 0 || onChangeHandler(key);
  }, [isUncontrolled, onChangeHandler]);
  return {
    selectedKeyMaybeUncontrolled: isUncontrolled ? uncontrolledSelectedKey : selectedKey,
    onChangeMaybeUncontrolled
  };
}
export default useOnChangeTrackUncontrolled;
//# sourceMappingURL=useOnChangeTrackUncontrolled.js.map